import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Guide from './pages/Guide';
import LangSelect from './pages/LangSelect';
import RentTutorial from './pages/RentTutorial';
import ReturnTutorial from './pages/ReturnTutorial';
import LocationSetting from './pages/LocationSetting';

import OkunoShimaHome from './pages/Okuno-shima/Home';
import OkunoShimaGuide from './pages/Okuno-shima/Guide';
import OkunoShimaLangSelect from './pages/Okuno-shima/LangSelect';
import OkunoShimaRentTutorial from './pages/Okuno-shima/RentTutorial';
import OkunoShimaReturnTutorial from './pages/Okuno-shima/ReturnTutorial';
import OkunoShimaLocationSetting from './pages/Okuno-shima/LocationSetting';

import InuyamaHome from './pages/Inuyama/Home';
import InuyamaGuide from './pages/Inuyama/Guide';
import InuyamaLangSelect from './pages/Inuyama/LangSelect';
import InuyamaRentTutorial from './pages/Inuyama/RentTutorial';
import InuyamaReturnTutorial from './pages/Inuyama/ReturnTutorial';
import InuyamaLocationSetting from './pages/Inuyama/LocationSetting';

import EdajimaLangSelect from './pages/Edajima/LangSelect';
import EdajimaHome from './pages/Edajima/Home';
import EdajimaHowToUseEcoSlide from './components/HowToUseEcoSlide';
import EdajimaGuide from './pages/Edajima/Guide';
import EdajimaLocationSetting from './pages/Edajima/LocationSetting';

import EdajimaNakamachiLangSelect from './pages/Edajima/Nakamachi/LangSelect';
import EdajimaNakamachiHome from './pages/Edajima/Nakamachi/Home';
import EdajimaNakamachiGuide from './pages/Edajima/Nakamachi/Guide';
import EdajimaNakamachiLocationSetting from './pages/Edajima/Nakamachi/LocationSetting';
import EdajimaNakamachiRentTutorial from './pages/Edajima/Nakamachi/RentTutorial';
import EdajimaNakamachiReturnTutorial from './pages/Edajima/Nakamachi/ReturnTutorial';

import TakaradukaLangSelect from './pages/Takaraduka/LangSelect';
import TakaradukaHome from './pages/Takaraduka/Home';
import TakaradukaMobilitySelect from './pages/Takaraduka/MobilitySelect';
import TakaradukaGuideCwalk from './pages/Takaraduka/GuideCwalk';
import TakaradukaGuideWhill from './pages/Takaraduka/GuideWhill';
import TakaradukaCwalkRentTutorial from './pages/Takaraduka/RentTutorial';
import TakaradukaCwalkReturnTutorial from './pages/Takaraduka/ReturnTutorial';
import TakaradukaWhillRentTutorial from './pages/Takaraduka/HowToRentWhill';
import TakaradukaWhillReturnTutorial from './pages/Takaraduka/HowToReturnWhill';
import TakaradukaLocationSettingCwalk from './pages/Takaraduka/LocationSettingcwalk';
import TakaradukaLocationSettingWhill from './pages/Takaraduka/LocationSettingwhill';

import HimakajimaLangSelect from './pages/Himakajima/LangSelect';
import HimakajimaHome from './pages/Himakajima/Home';
import HimakajimaGuide from './pages/Himakajima/Guide';
import HimakajimaRentTutorial from './pages/Himakajima/RentTutorial';
import HimakajimaReturnTutorial from './pages/Himakajima/ReturnTutorial';
import HimakajimaLocationSetting from './pages/Himakajima/LocationSetting';

import TennouzuLangSelect from './pages/Tennouzu/LangSelect';
import TennouzuHome from './pages/Tennouzu/Home';
import TennouzuGuide from './pages/Tennouzu/Guide';
import TennouzuRentTutorial from './pages/Tennouzu/RentTutorial';
import TennouzuReturnTutorial from './pages/Tennouzu/ReturnTutorial';
import TennouzuLocationSetting from './pages/Tennouzu/LocationSetting';

import ShirahamaLangSelect from './pages/Shirahama/LangSelect';
import ShirahamaHome from './pages/Shirahama/Home';
import ShirahamaGuide from './pages/Shirahama/Guide';
import ShirahamaRentTutorial from './pages/Shirahama/RentTutorial';
import ShirahamaReturnTutorial from './pages/Shirahama/ReturnTutorial';
import ShirahamaLocationSetting from './pages/Shirahama/LocationSetting';

import HamamatsuLangSelect from './pages/Hamamatsu/LangSelect';
import HamamatsuHome from './pages/Hamamatsu/Home';
import HamamatsuGuide from './pages/Hamamatsu/Guide';
import HamamatsuHowToUseEcoSlide from './pages/Hamamatsu/HowToUseEcoSlide';
import HamamatsuLocationSetting from './pages/Hamamatsu/LocationSetting';
import HamamatsuThanksPage from './pages/Hamamatsu/ThanksPage';

import TamaChuoParkLangSelect from './pages/TamaChuoPark/LangSelect';
import TamaChuoParkHome from './pages/TamaChuoPark/Home';
import TamaChuoParkGuide from './pages/TamaChuoPark/Guide';
import TamaChuoParkRentTutorial from './pages/TamaChuoPark/RentTutorial';
import TamaChuoParkReturnTutorial from './pages/TamaChuoPark/ReturnTutorial';
import TamaChuoParkLocationSetting from './pages/TamaChuoPark/LocationSetting';

import HattoriRyokuchiLangSelect from './pages/HattoriRyokuchi/LangSelect';
import HattoriRyokuchiHome from './pages/HattoriRyokuchi/Home';
import HattoriRyokuchiGuide from './pages/HattoriRyokuchi/Guide';
import HattoriRyokuchiRentTutorial from './pages/HattoriRyokuchi/RentTutorialCwalks';
import HattoriRyokuchiReturnTutorial from './pages/HattoriRyokuchi/ReturnTutorialCwalks';
import HattoriRyokuchiLocationSetting from './pages/HattoriRyokuchi/LocationSetting';

import UchikoLangSelect from './pages/Uchiko/LangSelect';
import UchikoHome from './pages/Uchiko/Home';
import UchikoGuide from './pages/Uchiko/Guide';
import UchikoLocationSetting from './pages/Uchiko/LocationSetting';

import ShobaraLangSelect from './pages/Shobara/LangSelect';
import ShobaraHome from './pages/Shobara/Home';
import ShobaraGuide from './pages/Shobara/Guide';
import ShobaraRentTutorial from './pages/Shobara/RentTutorial';
import ShobaraReturnTutorial from './pages/Shobara/ReturnTutorial';
import ShobaraLocationSetting from './pages/Shobara/LocationSetting';

import DaikunosatoLangSelect from './pages/Daikunosato/LangSelect';
import DaikunosatoHome from './pages/Daikunosato/Home';
import DaikunosatoGuide from './pages/Daikunosato/Guide';
import DaikunosatoRentTutorial from './pages/Daikunosato/RentTutorial';
import DaikunosatoReturnTutorial from './pages/Daikunosato/ReturnTutorial';
import DaikunosatoLocationSetting from './pages/Daikunosato/LocationSetting';

import HeiwajimaGuide from './pages/Heiwajima/Guide';
import HeiwajimaLocationSetting from './pages/Heiwajima/LocationSetting';
import HeiwajimaReturnTutorial from './pages/Heiwajima/HowToReturnWhill';
import HeiwajimaLangSelect from './pages/Heiwajima/LangSelect';
import HeiwajimaHome from './pages/Heiwajima/Home';
import HeiwajimaRentTutorial from './pages/Heiwajima/HowToRentWhill';

import TatsuminomoriLangSelect from './pages/Tatsuminomori/LangSelect';
import TatsuminomoriHome from './pages/Tatsuminomori/Home';
import TatsuminomoriGuide from './pages/Tatsuminomori/Guide';
import TatsuminomoriRentTutorial from './pages/Tatsuminomori/RentTutorial';
import TatsuminomoriReturnTutorial from './pages/Tatsuminomori/ReturnTutorial';
import TatsuminomoriLocationSetting from './pages/Tatsuminomori/LocationSetting';

import YamatomuseumLangSelect from './pages/Yamatomuseum/LangSelect';
import YamatomuseumHome from './pages/Yamatomuseum/Home';
import YamatomuseumGuide from './pages/Yamatomuseum/Guide';
import YamatomuseumRentTutorial from './pages/Yamatomuseum/RentTutorial';
import YamatomuseumReturnTutorial from './pages/Yamatomuseum/ReturnTutorial';
import YamatomuseumLocationSetting from './pages/Yamatomuseum/LocationSetting';

import UchikoMobilityLangSelect from './pages/UchikoMobility/LangSelect';
import UchikoMobilityHome from './pages/UchikoMobility/Home';
import UchikoMobilityGuide from './pages/UchikoMobility/Guide';
import UchikoMobilityRentTutorial from './pages/UchikoMobility/RentTutorial';
import UchikoMobilityReturnTutorial from './pages/UchikoMobility/ReturnTutorial';
import UchikoMobilityLocationSetting from './pages/UchikoMobility/LocationSetting';

import SunamachiLangSelect from './pages/Sunamachi/LangSelect';
import SunamachiHome from './pages/Sunamachi/Home';
import SunamachiGuide from './pages/Sunamachi/Guide';
import SunamachiRentTutorial from './pages/Sunamachi/RentTutorial';
import SunamachiReturnTutorial from './pages/Sunamachi/ReturnTutorial';
import SunamachiLocationSetting from './pages/Sunamachi/LocationSetting';

import MeijimuraLangSelect from './pages/Meijimura/LangSelect';
import MeijimuraHome from './pages/Meijimura/Home';
import MeijimuraGuide from './pages/Meijimura/Guide';
import MeijimuraLocationSetting from './pages/Meijimura/LocationSetting';
import MeijimuraCouponInfo from './pages/Meijimura/CouponInfo';
import MeijimuraCouponReward from './pages/Meijimura/CouponReward';
import MeijimuraSatisfactionSurvey from './pages/Meijimura/SatisfactionSurvey';

import ThanksPage from './pages/ThanksPage';

import Analytics from './pages/Analytics';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin" element={<Analytics />} />
        <Route path="/" element={<LangSelect />} />
        <Route path="/guide" element={<Guide />} />
        <Route path="/home" element={<Home />} />
        <Route path="/renttutorial" element={<RentTutorial />} />
        <Route path="/returntutorial" element={<ReturnTutorial />} />
        <Route path="/locationsetting" element={<LocationSetting />} />
        <Route path="/okuno-shima/home" element={<OkunoShimaHome />} />
        <Route path="/okuno-shima/guide" element={<OkunoShimaGuide />} />
        <Route path="/okuno-shima" element={<OkunoShimaLangSelect />} />
        <Route path="/okuno-shima/renttutorial" element={<OkunoShimaRentTutorial />} />
        <Route path="/okuno-shima/returntutorial" element={<OkunoShimaReturnTutorial />} />
        <Route path="/okuno-shima/locationsetting" element={<OkunoShimaLocationSetting />} />
        <Route path="/Inuyama/home" element={<InuyamaHome />} />
        <Route path="/Inuyama/guide" element={<InuyamaGuide />} />
        <Route path="/Inuyama" element={<InuyamaLangSelect />} />
        <Route path="/Inuyama/renttutorial" element={<InuyamaRentTutorial />} />
        <Route path="/Inuyama/returntutorial" element={<InuyamaReturnTutorial />} />
        <Route path="/Inuyama/locationsetting" element={<InuyamaLocationSetting />} />
        <Route path="/Etajima" element={<EdajimaLangSelect />} />
        <Route path="/Etajima/home" element={<EdajimaHome />} />
        <Route path="/Etajima/howtouseecoslide" element={<EdajimaHowToUseEcoSlide />} />
        <Route path="/Etajima/guide" element={<EdajimaGuide />} />
        <Route path="/Etajima/locationsetting" element={<EdajimaLocationSetting />} />
        <Route path="/thanks" element={<ThanksPage />} />
        <Route path="/etajima/nakamachi" element={<EdajimaNakamachiLangSelect />} />
        <Route path="/etajima/nakamachi/home" element={<EdajimaNakamachiHome />} />
        <Route path="/etajima/nakamachi/guide" element={<EdajimaNakamachiGuide />} />
        <Route path="/etajima/nakamachi/locationsetting" element={<EdajimaNakamachiLocationSetting />} />
        <Route path="/etajima/nakamachi/renttutorial" element={<EdajimaNakamachiRentTutorial />} />
        <Route path="/etajima/nakamachi/returntutorial" element={<EdajimaNakamachiReturnTutorial />} />
        <Route path="/takaraduka" element={<TakaradukaLangSelect />} />
        <Route path="/takaraduka/home" element={<TakaradukaHome />} />
        <Route path="/takaraduka/mobilityselect" element={<TakaradukaMobilitySelect />} />
        <Route path="/takaraduka/guidecwalk" element={<TakaradukaGuideCwalk />} />
        <Route path="/takaraduka/guidewhill" element={<TakaradukaGuideWhill />} />
        <Route path="/takaraduka/renttutorial" element={<TakaradukaCwalkRentTutorial />} />
        <Route path="/takaraduka/returntutorial" element={<TakaradukaCwalkReturnTutorial />} />
        <Route path="/takaraduka/howtorentwhill" element={<TakaradukaWhillRentTutorial />} />
        <Route path="/takaraduka/howtoreturnwhill" element={<TakaradukaWhillReturnTutorial />} />
        <Route path="/takaraduka/locationsettingcwalk" element={<TakaradukaLocationSettingCwalk />} />
        <Route path="/takaraduka/locationsettingwhill" element={<TakaradukaLocationSettingWhill />} />
        <Route path="/himakajima" element={<HimakajimaLangSelect />} />
        <Route path="/himakajima/home" element={<HimakajimaHome />} />
        <Route path="/himakajima/guide" element={<HimakajimaGuide />} />
        <Route path="/himakajima/renttutorial" element={<HimakajimaRentTutorial />} />
        <Route path="/himakajima/returntutorial" element={<HimakajimaReturnTutorial />} />
        <Route path="/himakajima/locationsetting" element={<HimakajimaLocationSetting />} />
        <Route path="/tennouzu" element={<TennouzuLangSelect />} />
        <Route path="/tennouzu/home" element={<TennouzuHome />} />
        <Route path="/tennouzu/guide" element={<TennouzuGuide />} />
        <Route path="/tennouzu/renttutorial" element={<TennouzuRentTutorial />} />
        <Route path="/tennouzu/returntutorial" element={<TennouzuReturnTutorial />} />
        <Route path="/tennouzu/locationsetting" element={<TennouzuLocationSetting />} />
        <Route path="/shirahama" element={<ShirahamaLangSelect />} />
        <Route path="/shirahama/home" element={<ShirahamaHome />} />
        <Route path="/shirahama/guide" element={<ShirahamaGuide />} />
        <Route path="/shirahama/renttutorial" element={<ShirahamaRentTutorial />} />
        <Route path="/shirahama/returntutorial" element={<ShirahamaReturnTutorial />} />
        <Route path="/shirahama/locationsetting" element={<ShirahamaLocationSetting />} />
        <Route path="/hamamatsu" element={<HamamatsuLangSelect />} />
        <Route path="/hamamatsu/home" element={<HamamatsuHome />} />
        <Route path="/hamamatsu/howtouseecoslide" element={<HamamatsuHowToUseEcoSlide />} />
        <Route path="/hamamatsu/guide" element={<HamamatsuGuide />} />
        <Route path="/hamamatsu/locationsetting" element={<HamamatsuLocationSetting />} />
        <Route path="/hamamatsu/thanks" element={<HamamatsuThanksPage />} />
        <Route path="/tamachuopark" element={<TamaChuoParkLangSelect />} />
        <Route path="/tamachuopark/home" element={<TamaChuoParkHome />} />
        <Route path="/tamachuopark/guide" element={<TamaChuoParkGuide />} />
        <Route path="/tamachuopark/renttutorial" element={<TamaChuoParkRentTutorial />} />
        <Route path="/tamachuopark/returntutorial" element={<TamaChuoParkReturnTutorial />} />
        <Route path="/tamachuopark/locationsetting" element={<TamaChuoParkLocationSetting />} />
        <Route path="/hattoriryokuchi" element={<HattoriRyokuchiLangSelect />} />
        <Route path="/hattoriryokuchi/home" element={<HattoriRyokuchiHome />} />
        <Route path="/hattoriryokuchi/guide" element={<HattoriRyokuchiGuide />} />
        <Route path="/hattoriryokuchi/renttutorial" element={<HattoriRyokuchiRentTutorial />} />
        <Route path="/hattoriryokuchi/returntutorial" element={<HattoriRyokuchiReturnTutorial />} />
        <Route path="/hattoriryokuchi/locationsetting" element={<HattoriRyokuchiLocationSetting />} />
        <Route path="/uchiko" element={<UchikoLangSelect />} />
        <Route path="/uchiko/home" element={<UchikoHome />} />
        <Route path="/uchiko/guide" element={<UchikoGuide />} />
        <Route path="/uchiko/locationsetting" element={<UchikoLocationSetting />} />
        <Route path="/uchikomobility" element={<UchikoMobilityLangSelect />} />
        <Route path="/uchikomobility/home" element={<UchikoMobilityHome />} />
        <Route path="/uchikomobility/guide" element={<UchikoMobilityGuide />} />
        <Route path="/uchikomobility/renttutorial" element={<UchikoMobilityRentTutorial />} />
        <Route path="/uchikomobility/returntutorial" element={<UchikoMobilityReturnTutorial />} />
        <Route path="/uchikomobility/locationsetting" element={<UchikoMobilityLocationSetting />} />
        <Route path="/shobara" element={<ShobaraLangSelect />} />
        <Route path="/shobara/home" element={<ShobaraHome />} />
        <Route path="/shobara/guide" element={<ShobaraGuide />} />
        <Route path="/shobara/renttutorial" element={<ShobaraRentTutorial />} />
        <Route path="/shobara/returntutorial" element={<ShobaraReturnTutorial />} />
        <Route path="/shobara/locationsetting" element={<ShobaraLocationSetting />} />
        <Route path="/daikunosato" element={<DaikunosatoLangSelect />} />
        <Route path="/daikunosato/home" element={<DaikunosatoHome />} />
        <Route path="/daikunosato/guide" element={<DaikunosatoGuide />} />
        <Route path="/daikunosato/renttutorial" element={<DaikunosatoRentTutorial />} />
        <Route path="/daikunosato/returntutorial" element={<DaikunosatoReturnTutorial />} />
        <Route path="/daikunosato/locationsetting" element={<DaikunosatoLocationSetting />} />
        <Route path="/heiwajima/howtoreturnwhill" element={<HeiwajimaReturnTutorial />} />
        <Route path="/heiwajima/guide" element={<HeiwajimaGuide />} />
        <Route path="/heiwajima/locationsetting" element={<HeiwajimaLocationSetting />} />
        <Route path="/heiwajima" element={<HeiwajimaLangSelect />} />
        <Route path="/heiwajima/home" element={<HeiwajimaHome />} />
        <Route path="/heiwajima/howtorentwhill" element={<HeiwajimaRentTutorial />} />
        <Route path="/tatsuminomori" element={<TatsuminomoriLangSelect />} />
        <Route path="/tatsuminomori/home" element={<TatsuminomoriHome />} />
        <Route path="/tatsuminomori/guide" element={<TatsuminomoriGuide />} />
        <Route path="/tatsuminomori/renttutorial" element={<TatsuminomoriRentTutorial />} />
        <Route path="/tatsuminomori/returntutorial" element={<TatsuminomoriReturnTutorial />} />
        <Route path="/tatsuminomori/locationsetting" element={<TatsuminomoriLocationSetting />} />
        <Route path="/yamatomuseum" element={<YamatomuseumLangSelect />} />
        <Route path="/yamatomuseum/home" element={<YamatomuseumHome />} />
        <Route path="/yamatomuseum/guide" element={<YamatomuseumGuide />} />
        <Route path="/yamatomuseum/renttutorial" element={<YamatomuseumRentTutorial />} />
        <Route path="/yamatomuseum/returntutorial" element={<YamatomuseumReturnTutorial />} />
        <Route path="/yamatomuseum/locationsetting" element={<YamatomuseumLocationSetting />} />
        <Route path="/sunamachi" element={<SunamachiLangSelect />} />
        <Route path="/sunamachi/home" element={<SunamachiHome />} />
        <Route path="/sunamachi/guide" element={<SunamachiGuide />} />
        <Route path="/sunamachi/renttutorial" element={<SunamachiRentTutorial />} />
        <Route path="/sunamachi/returntutorial" element={<SunamachiReturnTutorial />} />
        <Route path="/sunamachi/locationsetting" element={<SunamachiLocationSetting />} />
        <Route path="/meijimura" element={<MeijimuraLangSelect />} />
        <Route path="/meijimura/home" element={<MeijimuraHome />} />
        <Route path="/meijimura/guide" element={<MeijimuraGuide />} />
        <Route path="/meijimura/locationsetting" element={<MeijimuraLocationSetting />} />
        <Route path="/meijimura/couponinfo" element={<MeijimuraCouponInfo />} />
        <Route path="/meijimura/couponreward" element={<MeijimuraCouponReward />} />
        <Route path="/meijimura/satisfactionsurvey" element={<MeijimuraSatisfactionSurvey />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
